export const MuiInputAdornment = {
  styleOverrides: {
    root: {
      marginRight: '0',
    },
  },
};
